import { Directive, input } from '@angular/core'

import { Card } from 'app/core/cms/type-unions'

import { CARD_MAPPING } from './cards/card-mapping.const'
import { DynamicInsert } from './dynamic-insert'

@Directive({ selector: 'ng-template[paiInsertDynamicCard]', standalone: true })
export class InsertDynamicCardDirective extends DynamicInsert<typeof CARD_MAPPING> {
  readonly data = input.required<Card>({ alias: 'paiInsertDynamicCard' })
  protected readonly blockMapping = CARD_MAPPING
}
